import React from 'react';
import StepperProps from './stepperProps';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import './stepper.scss';
import { debounce } from 'lodash';

const Stepper: React.FC<StepperProps> = (props) => {

    const debounceInputChange = debounce((value: string) => {
        props.onInputChange(value);
    }, 100);

    const internalOnInputChange = (event: any) => {
        if (props.preventDefaultOnChangeEvent)
            event.preventDefault();
        const value: string = event.target.value;
        if (props.debouceOnChangeEvent === true)
            debounceInputChange(value);
        else
            props.onInputChange(value);
    }

    return (
        <>
            <div className="bg-init-payment">
                <div className={`bg-input-init-payment ${props.red ? 'red' : ''}`}>
                    <button
                        onClick={props.onRemoveButtonClicked}
                        className="minus" style={{ cursor: 'pointer', color: 'white' }}>
                        <RemoveIcon color="inherit" style={{ verticalAlign: 'middle' }} />
                    </button>
                    <span>
                        <input
                            // min="1"
                            onChange={internalOnInputChange}
                            className="input-tokens"
                            type="text"
                            pattern="[0-9]*"
                            value={props.inputDefaultValue}
                            max="1000" />
                    </span>
                    <button
                        className="add" style={{ cursor: 'pointer' }}
                        onClick={props.onAddButtonClicked} >
                        <AddIcon style={{ verticalAlign: 'middle' }} />
                    </button>
                </div>
            </div>
        </>
    );
};

export default Stepper;
